var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgTommy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.411,
    height: 122.272,
    viewBox: "0 0 80.411 122.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.69,
    y1: 0.555,
    x2: -4.727,
    y2: 0.555,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4d4f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.441,
    y1: 0.482,
    x2: -3.563,
    y2: 0.482,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.465,
    y1: 0.561,
    x2: -5.395,
    y2: 0.561,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4d4f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10.384,
    y1: 1.78,
    x2: -9.42,
    y2: 1.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -8.827,
    y1: 1.314,
    x2: -7.949,
    y2: 1.314,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -12.004,
    y1: 2.602,
    x2: -10.934,
    y2: 2.602,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 0.03,
    x2: 0.5,
    y2: 6.114,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447,
    stopColor: "#f0f3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#dee5fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#c4d0f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abbdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 0.131,
    x2: 0.5,
    y2: 0.909,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abbdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.521,
    y1: 1,
    x2: 0.521,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.528,
    y1: 1,
    x2: 0.528,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4eac3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -8.534,
    y1: -13.202,
    x2: -7.897,
    y2: -13.202,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -16.905,
    y1: -9.41,
    x2: -15.905,
    y2: -9.41,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -3.239,
    y1: 1,
    x2: -3.239,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -4.317,
    y1: 1,
    x2: -4.317,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -5.933,
    y1: -7.288,
    x2: -4.933,
    y2: -7.288,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#abbdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#abbdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#c9d5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#e1e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#f1f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -1.911,
    y1: -7.268,
    x2: -0.911,
    y2: -7.268,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.5,
    y1: 0.024,
    x2: 0.5,
    y2: 1.014,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fbfcfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#f1f4fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#e1e7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#c9d5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#abbdf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#abbdf6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    y1: 0.172,
    y2: 2.006,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.5,
    y1: 0.064,
    x2: 0.5,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#899b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#255300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -2.438,
    y1: 1,
    x2: -2.438,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -26.494,
    y1: 1,
    x2: -26.494,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.576,
    y1: 1,
    x2: 0.576,
    y2: 0,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Robot",
    transform: "translate(-1936.595 -1174.411)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow",
    cx: 16.18,
    cy: 3.177,
    rx: 16.18,
    ry: 3.177,
    transform: "translate(1960.203 1290.328)",
    fill: "#255300"
  }), /*#__PURE__*/React.createElement("g", {
    id: "R_Hand",
    "data-name": "R Hand",
    transform: "translate(2002.155 1230.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9578",
    "data-name": "Tracciato 9578",
    d: "M2912.791,2297.641q-.367.074-.736.115c3.922,10.093,7.911,12.836,7.911,12.836s4.843,3.51,1.99-15.873q-.282-1.922-.645-3.706c-.424.612-.9,1.251-1.437,1.883a15.7,15.7,0,0,1-4.393,3.746A9.61,9.61,0,0,1,2912.791,2297.641Z",
    transform: "translate(-2908.005 -2267.293)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9579",
    "data-name": "Tracciato 9579",
    d: "M2857.987,1985.248q.438,1.352.885,2.569c2.489-.154,4.93-1.632,7.282-4.415a24.8,24.8,0,0,0,2.064-2.854c-2.75-11.978-7.811-19-10-21.6a.92.92,0,0,0-1.583.323C2855.583,1962.717,2853.682,1971.984,2857.987,1985.248Z",
    transform: "translate(-2855.297 -1958.617)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9580",
    "data-name": "Tracciato 9580",
    d: "M2905.389,2273.214q.238.649.476,1.263.368-.041.735-.115a9.589,9.589,0,0,0,2.691-1,15.7,15.7,0,0,0,4.393-3.746c.533-.632,1.013-1.271,1.436-1.883q-.183-.913-.385-1.789a24.741,24.741,0,0,1-2.064,2.854C2910.319,2271.582,2907.877,2273.06,2905.389,2273.214Z",
    transform: "translate(-2901.814 -2244.014)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L_Hand",
    "data-name": "L Hand",
    transform: "translate(1936.595 1230.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9581",
    "data-name": "Tracciato 9581",
    d: "M1946.66,2297.641q.367.074.735.115c-3.922,10.093-7.911,12.836-7.911,12.836s-4.843,3.51-1.99-15.873q.283-1.922.645-3.706c.424.612.9,1.251,1.436,1.883a15.7,15.7,0,0,0,4.393,3.746A9.6,9.6,0,0,0,1946.66,2297.641Z",
    transform: "translate(-1936.595 -2267.293)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9582",
    "data-name": "Tracciato 9582",
    d: "M1973.872,1985.248q-.439,1.352-.885,2.569c-2.489-.154-4.93-1.632-7.282-4.415a24.774,24.774,0,0,1-2.064-2.854c2.75-11.978,7.811-19,10-21.6a.92.92,0,0,1,1.583.323C1976.276,1962.717,1978.177,1971.984,1973.872,1985.248Z",
    transform: "translate(-1961.711 -1958.617)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9583",
    "data-name": "Tracciato 9583",
    d: "M1967.973,2273.214q-.238.649-.476,1.263-.368-.041-.735-.115a9.586,9.586,0,0,1-2.691-1,15.7,15.7,0,0,1-4.393-3.746c-.532-.632-1.013-1.271-1.436-1.883q.183-.913.385-1.789a24.737,24.737,0,0,0,2.064,2.854C1963.043,2271.582,1965.485,2273.06,1967.973,2273.214Z",
    transform: "translate(-1956.697 -2244.014)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(1946.2 1224.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4591",
    "data-name": "Raggruppa 4591",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9584",
    "data-name": "Tracciato 9584",
    d: "M2111.587,1887.4c12.017,0,23.115-1.5,29.848-4.023-.037-.072-.077-.141-.118-.211l-2.677-3.5-3.612-4.3-.482-.575c-2.23-1.554-11.662-2.719-22.958-2.719s-20.728,1.165-22.958,2.719l-.483.575-3.612,4.3-2.677,3.5c-.041.07-.08.14-.117.211C2088.472,1885.905,2099.569,1887.4,2111.587,1887.4Z",
    transform: "translate(-2080.987 -1872.078)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9585",
    "data-name": "Tracciato 9585",
    d: "M2071.308,2053c1.81,9.581,9.847,44.674,30.489,44.674s28.679-35.093,30.489-44.674a6.4,6.4,0,0,0-.093-2.787c-6.9,2.589-18.2,4.126-30.4,4.126s-23.5-1.538-30.4-4.126A6.393,6.393,0,0,0,2071.308,2053Z",
    transform: "translate(-2071.197 -2037.503)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_23",
    "data-name": "Ellisse 23",
    cx: 21.184,
    cy: 2.604,
    rx: 21.184,
    ry: 2.604,
    transform: "translate(9.416 1.405)",
    fill: "#c2d1f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9586",
    "data-name": "Tracciato 9586",
    d: "M2074.048,2031.889c6.9,2.589,18.2,4.126,30.4,4.126s23.5-1.538,30.4-4.126a6.344,6.344,0,0,0-.549-1.408c-6.733,2.523-17.83,4.023-29.848,4.023s-23.115-1.5-29.848-4.023A6.38,6.38,0,0,0,2074.048,2031.889Z",
    transform: "translate(-2073.844 -2019.177)",
    fill: "url(#linear-gradient-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4592",
    "data-name": "Raggruppa 4592",
    transform: "translate(14.688 22.041)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_24",
    "data-name": "Ellisse 24",
    cx: 3.326,
    cy: 3.326,
    r: 3.326,
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_25",
    "data-name": "Ellisse 25",
    cx: 2.582,
    cy: 2.582,
    r: 2.582,
    transform: "translate(0.745 0.745)",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4593",
    "data-name": "Raggruppa 4593",
    transform: "translate(24.348 22.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9587",
    "data-name": "Tracciato 9587",
    d: "M2420.808,2188.8a3.93,3.93,0,1,0,0-7.86h-4.5a3.93,3.93,0,0,0,0,7.86Z",
    transform: "translate(-2412.381 -2180.941)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_993",
    "data-name": "Rettangolo 993",
    width: 6.37,
    height: 10.867,
    rx: 3.185,
    transform: "translate(0.745 7.115) rotate(-90)",
    fill: "url(#linear-gradient-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4595",
    "data-name": "Raggruppa 4595",
    transform: "translate(39.71 22.041)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_26",
    "data-name": "Ellisse 26",
    cx: 3.326,
    cy: 3.326,
    r: 3.326,
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4594",
    "data-name": "Raggruppa 4594",
    transform: "translate(0.745 0.745)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_27",
    "data-name": "Ellisse 27",
    cx: 2.582,
    cy: 2.582,
    r: 2.582,
    fill: "url(#linear-gradient-15)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(1942.792 1174.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_994",
    "data-name": "Rettangolo 994",
    width: 14.264,
    height: 10.867,
    rx: 5.433,
    transform: "translate(57.15 31.18) rotate(-90)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_995",
    "data-name": "Rettangolo 995",
    width: 14.264,
    height: 10.867,
    rx: 5.433,
    transform: "translate(0 30.964) rotate(-90)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_996",
    "data-name": "Rettangolo 996",
    width: 59.669,
    height: 48.041,
    rx: 24.02,
    transform: "translate(63.843 48.041) rotate(180)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9588",
    "data-name": "Tracciato 9588",
    d: "M2213.238,1518.244q0-.439.024-.873a16,16,0,0,0,15.929,15.08h9.021a16.005,16.005,0,0,0,15.929-15.08q.023.433.024.873a16,16,0,0,1-15.954,15.953h-9.021A16,16,0,0,1,2213.238,1518.244Z",
    transform: "translate(-2199.694 -1492.897)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9589",
    "data-name": "Tracciato 9589",
    d: "M2213.262,1302.915a16,16,0,0,1,15.929-15.08h9.021a16.005,16.005,0,0,1,15.929,15.08q.023.434.024.873a16,16,0,0,1-15.954,15.953h-9.021a16,16,0,0,1-15.953-15.953Q2213.238,1303.349,2213.262,1302.915Z",
    transform: "translate(-2199.694 -1279.741)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9590",
    "data-name": "Tracciato 9590",
    d: "M2213.238,1279.327q0,.439.024.873a16,16,0,0,1,15.929-15.08h9.021a16.005,16.005,0,0,1,15.929,15.08q.023-.433.024-.873a16,16,0,0,0-15.954-15.953h-9.021A16,16,0,0,0,2213.238,1279.327Z",
    transform: "translate(-2199.694 -1257.025)",
    fill: "#899b3c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_28",
    "data-name": "Ellisse 28",
    cx: 2.582,
    cy: 4.098,
    rx: 2.582,
    ry: 4.098,
    transform: "translate(39.012 16.7)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_29",
    "data-name": "Ellisse 29",
    cx: 2.582,
    cy: 4.098,
    rx: 2.582,
    ry: 4.098,
    transform: "translate(23.007 16.7)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_9591",
    "data-name": "Tracciato 9591",
    d: "M2417.831,1571.954a.562.562,0,0,0-.56.62,5.518,5.518,0,0,0,10.967,0,.561.561,0,0,0-.56-.62Z",
    transform: "translate(-2389.163 -1543.585)",
    fill: "url(#linear-gradient-23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgTommy);
export default __webpack_public_path__ + "static/media/SvgTommy.f31be4460b2b96ca21a9fa0e92773f64.svg";
export { ForwardRef as ReactComponent };